// Section layout tokens on the MUI 8px spacing unit: 2rem = spacing(4),
// 1rem = spacing(2).
export const SECTION_MAX_WIDTH = '1280px';
export const SECTION_PADDING_INLINE = '2rem'; // desktop/tablet
export const SECTION_PADDING_INLINE_MOBILE = '1rem'; // <600px (sm)
